const getDataDogReleaseVersion = () =>
  `gitsha:${process.env.VERCEL_GIT_COMMIT_SHA}`

module.exports = getDataDogReleaseVersion
